import { useState, useEffect } from 'react'
import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { getUnreadCount } from '../../lib/erp'

// Icons
const IconHome = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
const IconFunnel = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
const IconBox = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>
const IconUsers = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
const IconDollar = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
const IconMapRoute = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" /><line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" /></svg>
const IconTicket = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 9a3 3 0 0 1 0 6v5h20v-5a3 3 0 0 1 0-6V4H2z" /><line x1="13" y1="4" x2="13" y2="9" /><line x1="13" y1="15" x2="13" y2="20" /></svg>
const IconCheckCircle = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
const IconBook = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
const IconSignal = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="2" /><path d="M16.24 7.76a6 6 0 0 1 0 8.49" /><path d="M7.76 16.24a6 6 0 0 1 0-8.49" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14" /><path d="M4.93 19.07a10 10 0 0 1 0-14.14" /></svg>
const IconMapPin = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
const IconPresence = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z"/><circle cx="12" cy="10" r="3"/></svg>
const IconActivity = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>
const IconBell = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>
const IconBack = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
const IconLogout = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
const IconMenu = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
const IconClose = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>

const navSections = [
  {
    label: 'PRINCIPAL',
    items: [
      { to: '/admin', label: 'Dashboard', icon: IconHome, end: true },
      { to: '/admin/pipeline', label: 'Pipeline', icon: IconFunnel },
      { to: '/admin/stock', label: 'Stock', icon: IconBox },
    ],
  },
  {
    label: 'EQUIPE',
    items: [
      { to: '/admin/equipe', label: 'Equipe', icon: IconUsers },
      { to: '/admin/finances', label: 'Finances', icon: IconDollar },
    ],
  },
  {
    label: 'PILOTAGE',
    items: [
      { to: '/admin/roadmap', label: 'Roadmap', icon: IconMapRoute },
      { to: '/admin/tickets', label: 'Tickets', icon: IconTicket },
      { to: '/admin/decisions', label: 'Decisions', icon: IconCheckCircle },
      { to: '/admin/journal', label: 'Journal', icon: IconBook },
    ],
  },
  {
    label: 'OPERATIONS',
    small: true,
    items: [
      { to: '/admin/chevalets', label: 'Chevalets NFC', icon: IconSignal },
      { to: '/admin/presence', label: 'Présence', icon: IconPresence },
      { to: '/admin/map', label: 'Carte', icon: IconMapPin },
      { to: '/admin/downdetector', label: 'Etat services', icon: IconActivity },
    ],
  },
]

function SidebarContent({ onNavClick }) {
  const { signOut } = useAuth()
  const navigate = useNavigate()
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    getUnreadCount().then(setUnreadCount).catch(() => {})
  }, [])

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <img src="/taprize-logo.png" alt="Taprize" className="h-12 w-auto object-contain" />
        <NavLink
          to="/admin/notifications"
          onClick={onNavClick}
          className="relative p-1.5 rounded-lg text-text-muted hover:text-text hover:bg-bg-input transition-colors"
        >
          <IconBell />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 bg-primary text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </NavLink>
      </div>
      <div className="mb-4 px-3 py-1.5 bg-primary/10 rounded-lg">
        <span className="text-xs font-semibold text-primary">Admin Taprize</span>
      </div>

      {/* Navigation */}
      <nav className="flex flex-col flex-1 overflow-y-auto">
        {navSections.map((section) => (
          <div key={section.label}>
            <div className="text-[10px] uppercase tracking-wider text-text-muted px-3 mt-4 mb-1">
              {section.label}
            </div>
            <div className="flex flex-col gap-0.5">
              {section.items.map(({ to, label, icon, end }) => {
                const NavIcon = icon
                return (
                  <NavLink
                    key={to}
                    to={to}
                    end={end}
                    onClick={onNavClick}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2 rounded-xl transition-colors ${
                        section.small ? 'text-xs' : 'text-sm'
                      } ${
                        isActive
                          ? 'bg-primary/10 text-primary'
                          : 'text-text-muted hover:text-text hover:bg-bg-input'
                      }`
                    }
                  >
                    <NavIcon />
                    {label}
                  </NavLink>
                )
              })}
            </div>
          </div>
        ))}
      </nav>

      {/* Bottom */}
      <div className="mt-auto pt-4 border-t border-border">
        <Link
          to="/dashboard"
          onClick={onNavClick}
          className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs text-text-muted hover:text-text hover:bg-bg-input transition-colors mb-2"
        >
          <IconBack />
          Dashboard commerçant
        </Link>
        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 text-sm text-text-muted hover:text-error transition-colors text-left px-3 py-2 cursor-pointer"
        >
          <IconLogout />
          Déconnexion
        </button>
      </div>
    </div>
  )
}

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false)

  const closeMobile = () => setMobileOpen(false)

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Mobile top bar */}
      <div className="md:hidden flex items-center justify-between px-4 py-3 bg-bg-card border-b border-border">
        <button
          onClick={() => setMobileOpen(true)}
          className="p-1 text-text-muted hover:text-text"
        >
          <IconMenu />
        </button>
        <img src="/taprize-logo.png" alt="Taprize" className="h-8 w-auto object-contain" />
        <div className="w-8" /> {/* spacer */}
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={closeMobile}
        />
      )}

      {/* Sidebar - mobile slide-in */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-bg-card border-r border-border p-6 transform transition-transform duration-200 md:hidden ${
          mobileOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex justify-end mb-2">
          <button onClick={closeMobile} className="p-1 text-text-muted hover:text-text">
            <IconClose />
          </button>
        </div>
        <SidebarContent onNavClick={closeMobile} />
      </aside>

      {/* Sidebar - desktop */}
      <aside className="hidden md:flex w-64 bg-bg-card border-r border-border p-6 flex-col">
        <SidebarContent onNavClick={() => {}} />
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6 md:p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
